<template>
    <div class="main">
        <div class="pp-container">
            <div class="privacy-policy">
                <SimplePageBuilder :response="response"></SimplePageBuilder>
            </div>
        </div>
    </div>
</template>
<script>
import { SimplePageBuilder } from '@freddiesflowers/frontend-component-library';
import { getButterCmsPage } from '@/helpers/ButterCmsHelpers';

export default {
    name: 'PrivacyPolicy',
    components: {
        SimplePageBuilder,
    },
    data() {
        return {
            response: [],
            appNode: document.getElementById('app'),
            config: { attributes: true, childList: true, subtree: true },
            observer: new MutationObserver(this.onNodeChange),
        };
    },
    mounted() {
        this.observer.observe(this.appNode, this.config);
    },
    methods: {
        deactivateGA() {
            const googleTrackingID = window.GA_TRACKING_ID;
            if (googleTrackingID) {
                window[`ga-disable-${googleTrackingID}`] = true;
            }
        },
        onNodeChange() {
            if (document.getElementById('deactivateGA')) {
                document.getElementById('deactivateGA').onclick = this.deactivateGA;
                this.observer.disconnect();
            }
        },
    },
    created() {
        getButterCmsPage('privacy-policy').then((res) => this.response = res);
    },
};
</script>

<style lang="scss">
.privacy-policy {
    text-align: left;
    width: 100%;
    margin: 0 auto;
    margin-top: 2.5rem;
    .teaser--text {
        max-width: unset;

        .heading--medium {
            font-size: 30px;
            line-height: 35px;
            margin-top: 15px;
            text-align: left;
        }
        .heading--small {
            text-align: left;
        }
    }
}
.pp-container {
    max-width: 850px;
    width: 70%;
    margin: 0 auto;
    padding-bottom: 2.5rem;
}
</style>
